import { Table } from "reactstrap";
import Feature from "../feature-flag/Feature";
import { Transformer } from "../../model/viewModel/transformer";
import {
  transformerHasCommittedLoadConnections,
  getDateDisplayText,
  getStatusDisplayText,
  committedLoadFilter,
} from "../../utils/committedLoadFunctions";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface CommittedLoadReportTableProps {
  transformers: Transformer[];
}

const CommittedLoadReportTable = ({ transformers }: CommittedLoadReportTableProps) => {
  const { REACT_APP_THEME } = process.env;

  const includeCommittedLoadQuotationSent = useSelector(
    (state: RootState) => state.settings.isIncludeCommittedLoadQuotationSentEnabled,
  );

  return (
    <Feature flag="UseAcceptToConnectDataEnabled">
      {transformers.some(
        (t) =>
          transformerHasCommittedLoadConnections(t) &&
          t.committedLoad.connections.some((item) =>
            committedLoadFilter(item, includeCommittedLoadQuotationSent),
          ),
      ) && (
        <>
          <h5 style={{ paddingLeft: ".3rem" }}>Committed Loads</h5>
          <Table
            style={{ marginBottom: "3rem" }}
            className={`table-sm table-custom table-custom-${REACT_APP_THEME}`}
          >
            <thead>
              <tr className="mb-4">
                <th>Tx Number</th>
                <th>Enquiry Ref</th>
                <th>Date</th>
                <th>Import Capacity kVA</th>
                <th>Export Capacity kW</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transformers.filter(transformerHasCommittedLoadConnections).map((transformer) =>
                transformer.committedLoad.connections
                  .filter((item) => committedLoadFilter(item, includeCommittedLoadQuotationSent))
                  .map((connection) => (
                    <tr key={connection.enquiryReference}>
                      <td>{transformer.nodeNumber}</td>
                      <td>{connection.enquiryReference}</td>
                      <td>{getDateDisplayText(connection.date)}</td>
                      <td>{connection.importCapacitykVa}</td>
                      <td>{connection.exportCapacitykW}</td>
                      <td>{getStatusDisplayText(connection.status)}</td>
                    </tr>
                  )),
              )}
            </tbody>
          </Table>
        </>
      )}
    </Feature>
  );
};

export default CommittedLoadReportTable;
